import React, { useState } from "react";
import { Stack } from "@common-ui/ui";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
// import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { useFormik } from "formik";
import * as Yup from "yup";

import { createMaintenancePlans, addNewCustomerPlace } from "../../services";

import AlertDialog from "./AlertDialog";
import { Typography } from "@mui/material";
import CreatePlaceDialogContent from "./places/CreatePlaceDialogNew";
export function CreatePlaceDialog(props) {
  // eslint-disable-next-line no-unused-vars
  const [open, setOpen] = React.useState(false);
  const [, setPlanSystemId] = useState(null);
  const [, setEntryMode] = useState("");

  const formik = useFormik({
    initialValues: {
      title: "",
      revision: "",
      description: "",
      notes: "",
      org: null,
    },
    validationSchema: Yup.object({
      title: Yup.string().trim().max(255).required("Title is required"),
      revision: Yup.string().trim(),
      description: Yup.string().trim(),
      notes: Yup.string().trim(),
      org: Yup.object().nullable().required("Org is required"),
    }),
    onSubmit: () => {
      async function submit() {
        let { title, revision, description, notes, org } = formik.values;
        let attributes = {
          title,
          revision,
          description,
          notes,
        };
        try {
          const payload = await onSubmit(attributes, org?.id);
          setPlanSystemId(payload?.system_id);
          setOpen(true);
        } catch (error) {
          alert(error.message);
          // if (error.message === "Request failed with status code 405") {
          //   alert(
          //     "A customer with the same name already exists. \nPlease use a different name."
          //   );
          // } else {
          //   alert(error.message);
          // }
          // alert(error);
          formik.setSubmitting(false);
        }
      }
      submit();
    },
  });

  const handleAddNewPlace = (attributes) => {
    // console.log("Attributes1", attributes);
    const addNewPlace = async () => {
      try {
        await addNewCustomerPlace(props.orgId, props.customerId, attributes);
        props.init();
        setOpen(true);
        props.setRefresh(true);
      } catch (error) {
        alert(error);
      }
    };
    addNewPlace();
  };

  const onSubmit = async (attributes, orgId, customerId) => {
    // console.log("attributes", attributes);
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await createMaintenancePlans(
          attributes,
          customerId,
          orgId
        );
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  };

  const handleClose = () => {
    // router.push({
    //   pathname: `/maintenance-plans/${planSystemId}/edit`,
    // });
    setOpen(false);
    props.handleClose();
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={() => {
          formik.handleReset();
          props.handleClose();
          setEntryMode("");
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        maxWidth="xl"
      >
        <>
          <DialogTitle id="alert-dialog-title" scroll="paper">
            <Stack sx={{ alignItems: "center" }}>
              <Typography variant="h4">Add a New Place</Typography>
            </Stack>
            {props.open ? (
              <IconButton
                aria-label="close"
                onClick={() => {
                  props.handleClose();
                  formik.handleReset();
                  setEntryMode("");
                }}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <CreatePlaceDialogContent
            {...props}
            handleAddNewPlace={handleAddNewPlace}
          />

          <AlertDialog
            handleClose={handleClose}
            open={open}
            name={formik.values.title}
          />
        </>
      </Dialog>
    </div>
  );
}
